import { useState, useCallback, useEffect } from 'react';
import * as api from 'app/api';
import dayjs from 'app/libs/dayjs';

function usePhoneCertification(pageType = null) {
	const [phoneCertificationInfo, setPhoneCertificationInfo] = useState(null);
	const [certificationCodeExpireTime, setCertificationCodeExpireTime] = useState(null);
	const [certificationCodeRemainTime, setCertificationCodeRemainTime] = useState(null);

	useEffect(() => {
		let timer;

		if (certificationCodeExpireTime) {
			timer = setInterval(() => {
				const diff = certificationCodeExpireTime - dayjs();

				if (diff < 1) {
					clearInterval(timer);
				}

				setCertificationCodeRemainTime(dayjs(diff));
			}, 500);
		}

		return () => {
			if (timer) {
				clearInterval(timer);
			}
		};
	}, [certificationCodeExpireTime]);

	const applyPhoneCertification = useCallback(
		async (phone, id) => {
			let result;
			if (pageType === 'hs') {
				const { data } = await api.postPhoneKey(phone, id);
				result = data;
			}
			if (!pageType && id === 'buyInquiry') {
				const { data } = await api.applyCertifyInquiry(phone, id);
				result = data;
			}
			if (!pageType && id !== 'buyInquiry') {
				const { data } = await api.applyPhoneCertification(phone, id);
				result = data;
			}

			if (certificationCodeExpireTime) {
				alert('인증번호가 재발급 되었습니다.');
			} else {
				alert('휴대전화번호로 인증번호가 전송되었습니다.');
			}

			setPhoneCertificationInfo(result);
			setCertificationCodeExpireTime(dayjs().clone().add(3, 'minutes'));

			return result;
		},
		[certificationCodeExpireTime, pageType],
	);

	const verifyPhoneCertification = useCallback(
		async (code, site) => {
			try {
				if (pageType === 'hs') {
					await api.postPhoneAuth(phoneCertificationInfo.key, code);
				}
				if (!pageType && site === 'buyInquiry') {
					await api.verifyCertifyInquiry(phoneCertificationInfo.key, code);
				}
				if (!pageType && site !== 'buyInquiry') {
					await api.verifyPhoneCertification(phoneCertificationInfo.key, code);
				}
				setCertificationCodeExpireTime(null);
				setCertificationCodeRemainTime(null);
				return phoneCertificationInfo;
			} catch (e) {
				throw e;
			}
		},
		[pageType, phoneCertificationInfo],
	);

	return {
		applyPhoneCertification,
		setPhoneCertificationInfo,
		verifyPhoneCertification,
		certificationCodeExpireTime,
		certificationCodeRemainTime,
		setCertificationCodeExpireTime,
		isCertificationExpired: certificationCodeRemainTime && parseInt(certificationCodeRemainTime.format('x'), 10) < 1,
	};
}

export default usePhoneCertification;
